module.exports = __webpack_public_path__ + "img/text-high-pressure-tech.47b7e10d.png";